import React, { useEffect, useState } from "react";

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
  Input,
  Label
} from "reactstrap";

import {
  getAds,
  addAd,
  deleteAd
} from "../../services/api/api-service";


const Ads = () => {

  const [ads, setAds] = useState([]);

  const [title, setTitle] = useState("");

  const [image, setImage] = useState("");

  const [link, setLink] = useState("");


  // ==============================
  // LOAD ADS
  // ==============================

  const loadAds = async () => {

    try {

      const data = await getAds();

      setAds(data || []);

    } catch (error) {

      console.log("Error loading ads:", error);

    }

  };


  useEffect(() => {

    loadAds();

  }, []);



  // ==============================
  // ADD AD
  // ==============================

  const handleAddAd = async () => {

    if (!image) {

      alert("Please enter Image URL");

      return;

    }


    const payload = {

      title,

      image,

      link,

      status: "active",

      date: new Date()

    };


    try {

      await addAd(payload);

      alert("Ad added successfully");

      setTitle("");

      setImage("");

      setLink("");

      loadAds();

    } catch (error) {

      console.log("Add Ad Error:", error);

      alert("Failed to add ad");

    }

  };



  // ==============================
  // DELETE AD
  // ==============================

  const handleDelete = async (id) => {

    try {

      await deleteAd(id);

      alert("Ad deleted");

      loadAds();

    } catch (error) {

      console.log("Delete Error:", error);

    }

  };



  return (

    <Container fluid>

      <Row>

        <Col lg="12">

          <Card>

            <CardBody>

              <CardTitle>
                Manage Ads
              </CardTitle>


              {/* TITLE */}

              <Label>
                Ad Title
              </Label>

              <Input

                value={title}

                onChange={(e) =>
                  setTitle(e.target.value)
                }

                placeholder="Enter Ad Title"

              />


              <br />


              {/* IMAGE */}

              <Label>
                Ad Image URL
              </Label>

              <Input

                value={image}

                onChange={(e) =>
                  setImage(e.target.value)
                }

                placeholder="Enter Image URL"

              />


              <br />


              {/* LINK */}

              <Label>
                Redirect Link (Optional)
              </Label>

              <Input

                value={link}

                onChange={(e) =>
                  setLink(e.target.value)
                }

                placeholder="https://example.com"

              />


              <br />


              <Button
                color="primary"
                onClick={handleAddAd}
              >

                Add Ad

              </Button>


            </CardBody>

          </Card>

        </Col>

      </Row>



      {/* =====================
          ADS LIST
      ====================== */}

      <Row>

        {ads.map((ad) => (

          <Col
            lg="4"
            key={ad.id}
          >

            <Card>

              <CardBody>

                <img

                  src={ad.image}

                  alt={ad.title}

                  style={{
                    width: "100%",
                    height: 150,
                    objectFit: "cover"
                  }}

                />


                <h5
                  style={{
                    marginTop: 10
                  }}
                >

                  {ad.title}

                </h5>


                <p>

                  {ad.link}

                </p>


                <Button

                  color="danger"

                  onClick={() =>
                    handleDelete(ad.id)
                  }

                >

                  Delete

                </Button>


              </CardBody>

            </Card>

          </Col>

        ))}

      </Row>

    </Container>

  );

};


export default Ads;